export const updateTickerItems = [
  "3 分钟前 · 新增合集《城市漫步影像集》共 26 条",
  "18 分钟前 · 热门视频《深夜厨房实录》更新至第 12 集",
  "今天 09:40 · 短视频合集《通勤 60 秒》补入 18 条",
  "今天 08:15 · 资源速查「硬核科普」频道新增 42 条",
  "昨天 22:30 · 专题《复古动画重看》整理完成",
  "昨天 20:05 · 本周热度榜刷新，前三名有变动",
];

export const quickEntries = [
  { label: "热门视频", href: "#hot", icon: "ri-fire-line" },
  { label: "短视频合集", href: "#sets", icon: "ri-film-line" },
  { label: "专题索引", href: "#index", icon: "ri-list-check-2" },
  { label: "资源速查", href: "#lookup", icon: "ri-search-eye-line" },
  { label: "什么好看", href: "#guide", icon: "ri-compass-3-line" },
  { label: "常见问答", href: "#faq", icon: "ri-question-line" },
];

export const heroStats = [
  { value: "1,286", label: "本周新增资源" },
  { value: "42", label: "在架专题合集" },
  { value: "18", label: "细分频道" },
];

export const collectionGroups = [
  "全部",
  "影像记录",
  "解压治愈",
  "知识科普",
  "动漫动画",
  "美食生活",
];

export const collections = [
  {
    index: "01",
    name: "城市漫步影像集",
    group: "影像记录",
    count: 148,
    desc: "跟着镜头走街串巷，一集一个街区的气味、声音和光线。",
  },
  {
    index: "02",
    name: "深夜解压合集",
    group: "解压治愈",
    count: 96,
    desc: "睡前一小时，把白天的噪音调小一点，留一点安静给自己。",
  },
  {
    index: "03",
    name: "硬核科普速览",
    group: "知识科普",
    count: 210,
    desc: "把长知识拆成三分钟一段，通勤路上刚好消化完一段。",
  },
  {
    index: "04",
    name: "复古动画重看",
    group: "动漫动画",
    count: 77,
    desc: "小时候看过的那几部，按年份重新排好，前奏一响就回神。",
  },
  {
    index: "05",
    name: "一人食厨房",
    group: "美食生活",
    count: 132,
    desc: "十五分钟一顿饭，锅铲和油声比教程本身更治愈。",
  },
  {
    index: "06",
    name: "公路与远方",
    group: "影像记录",
    count: 64,
    desc: "长途路上的光，和停下来时才看得见的那片云。",
  },
  {
    index: "07",
    name: "冷知识短打",
    group: "知识科普",
    count: 88,
    desc: "每集只回答一个问题，看完顺手就记住了。",
  },
  {
    index: "08",
    name: "通勤笑声合辑",
    group: "解压治愈",
    count: 115,
    desc: "早高峰的十五分钟，用一段笑声把状态先打开。",
  },
];

export const hotCategorys = ["全部", "热门", "影像记录", "知识科普", "美食生活", "动漫动画"];

export const hotUpdates = [
  {
    title: "《深夜厨房实录》第 12 集：凌晨两点的面",
    summary: "一个人守着一口锅，把失眠慢慢煮成一顿宵夜。",
    group: "美食生活",
    category: "热门",
    duration: "24:10",
    views: "12.4 万",
    time: "今天 09:40",
  },
  {
    title: "城市夜跑纪实：环湖一圈",
    summary: "路灯、呼吸声和偶尔经过的一只猫，构成了整条路线。",
    group: "影像记录",
    category: "热门",
    duration: "18:32",
    views: "8.7 万",
    time: "今天 09:10",
  },
  {
    title: "三分钟看懂：冰块为什么会自己裂开",
    summary: "从热胀冷缩讲到玻璃的脾气，看完能解释生活里很多事。",
    group: "知识科普",
    category: "热门",
    duration: "03:05",
    views: "21.6 万",
    time: "今天 08:55",
  },
  {
    title: "老动画主题曲联播（重置版）",
    summary: "前奏一起，弹幕就开始集体回忆那几年的下午。",
    group: "动漫动画",
    category: "热门",
    duration: "32:48",
    views: "15.2 万",
    time: "今天 08:20",
  },
  {
    title: "一人食：深夜番茄鸡蛋面",
    summary: "没有复杂步骤，只有锅铲、耐心和一点点盐。",
    group: "美食生活",
    category: "美食生活",
    duration: "12:24",
    views: "6.3 万",
    time: "今天 07:50",
  },
  {
    title: "通勤解压 60 秒：云的一天",
    summary: "把镜头对准天空，剩下的交给时间慢慢走。",
    group: "解压治愈",
    category: "影像记录",
    duration: "01:00",
    views: "9.8 万",
    time: "昨天 22:40",
  },
  {
    title: "拆解一台老相机：镜头、快门、光圈",
    summary: "一件件拆开看清楚，机械的浪漫原来这么具体。",
    group: "知识科普",
    category: "知识科普",
    duration: "16:18",
    views: "5.1 万",
    time: "昨天 21:30",
  },
  {
    title: "环城绿道骑行 Vlog",
    summary: "从东门出发绕一圈，刚好赶上湖边那场日落。",
    group: "影像记录",
    category: "影像记录",
    duration: "27:02",
    views: "7.6 万",
    time: "昨天 20:15",
  },
  {
    title: "童年零食试吃合集",
    summary: "每一样都带着操场的味道，吃的是记忆不是零食。",
    group: "美食生活",
    category: "美食生活",
    duration: "09:41",
    views: "11.3 万",
    time: "昨天 19:05",
  },
  {
    title: "手绘动画幕后：一帧是怎么来的",
    summary: "一支笔、二十四张纸，换来屏幕上的一秒钟。",
    group: "动漫动画",
    category: "动漫动画",
    duration: "14:07",
    views: "4.9 万",
    time: "昨天 18:20",
  },
];

export const watchMoods = [
  {
    key: "五分钟",
    label: "只有 5 分钟",
    note: "碎片时间也值得被认真对待",
    items: [
      { title: "《云的一天》", note: "看天空发呆，刚好够一次深呼吸" },
      { title: "《一分钟冷知识》", note: "一个问题、一个答案，不长" },
      { title: "《猫的午后》", note: "没有剧情，只有舒服" },
    ],
  },
  {
    key: "放空",
    label: "需要放空",
    note: "什么都不想，交给画面就好",
    items: [
      { title: "《深夜解压合集》", note: "白噪音配慢镜头，越看越安静" },
      { title: "《湖边慢镜》", note: "水面比脑子更平静" },
      { title: "《雨天窗边》", note: "听着雨声把思绪放空" },
    ],
  },
  {
    key: "涨知识",
    label: "想涨点知识",
    note: "看完能顺手讲给别人听",
    items: [
      { title: "《三分钟看懂》", note: "日常里的物理，其实很好玩" },
      { title: "《拆解老相机》", note: "机械结构背后的浪漫" },
      { title: "《地图上的城市》", note: "地名背后都藏着一段故事" },
    ],
  },
  {
    key: "笑一下",
    label: "只想笑一下",
    note: "越简单越好笑，不费脑",
    items: [
      { title: "《通勤笑声合辑》", note: "早高峰的快乐补给" },
      { title: "《办公室短打》", note: "打工人的共同语言" },
      { title: "《沙雕合集》", note: "不用问为什么，笑就完了" },
    ],
  },
];

export const shortVideoSets = [
  {
    name: "通勤 60 秒",
    count: 128,
    desc: "一站地的时间，刚好一条。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20quiet%20city%20street%20at%20morning%20light%2C%20warm%20cream%20and%20muted%20amber%20palette%2C%20simple%20geometric%20shapes%2C%20soft%20paper%20texture%2C%20clean%20editorial%20composition%2C%20no%20text&width=400&height=400&seq=sv-thumb-commute-01&orientation=squarish",
  },
  {
    name: "一镜到底",
    count: 86,
    desc: "不剪辑，看完整的过程。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20a%20small%20kitchen%20with%20steam%20rising%20from%20a%20pot%2C%20warm%20cream%20and%20soft%20vermillion%20tones%2C%20simple%20shapes%2C%20gentle%20paper%20texture%2C%20clean%20editorial%20composition%2C%20no%20text&width=400&height=400&seq=sv-thumb-kitchen-02&orientation=squarish",
  },
  {
    name: "城市碎片",
    count: 154,
    desc: "随手拍下的街道角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20cozy%20street%20corners%20and%20rooftops%2C%20warm%20cream%20and%20muted%20green%20accents%2C%20geometric%20shapes%2C%20soft%20paper%20texture%2C%20calm%20editorial%20style%2C%20no%20text&width=400&height=400&seq=sv-thumb-city-03&orientation=squarish",
  },
  {
    name: "解压循环",
    count: 97,
    desc: "适合放着当背景。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20gentle%20water%20ripples%20and%20floating%20leaves%2C%20warm%20cream%20and%20soft%20amber%20palette%2C%20simple%20organic%20shapes%2C%20soft%20texture%2C%20soothing%20calm%20editorial%20composition%2C%20no%20text&width=400&height=400&seq=sv-thumb-calm-04&orientation=squarish",
  },
];

export const lookupDimensions = [
  {
    key: "题材",
    hint: "先定方向，再挑内容",
    tags: ["纪录片", "短片", "动画", "科普", "美食", "旅行", "访谈", "运动"],
  },
  {
    key: "时长",
    hint: "按手边时间选",
    tags: ["1 分钟", "5 分钟", "15 分钟", "30 分钟", "60 分钟以上"],
  },
  {
    key: "场景",
    hint: "对应当下的状态",
    tags: ["通勤", "睡前", "周末", "做饭时", "午休", "陪家人"],
  },
  {
    key: "热度",
    hint: "跟着大家走",
    tags: ["本周热门", "长期霸榜", "新上线", "编辑推荐", "讨论最多"],
  },
];

export const lookupStats = [
  { value: "1,286", label: "本周新增", unit: "条资源" },
  { value: "18", label: "细分频道", unit: "个板块" },
  { value: "42", label: "在架合集", unit: "可浏览" },
  { value: "4", label: "查找维度", unit: "方式" },
];

export const trendingTopics = [
  { name: "今年有什么好看的纪录片", heat: 98, posts: "2,410" },
  { name: "适合睡前看的解压合集", heat: 92, posts: "1,860" },
  { name: "三分钟冷知识安利", heat: 87, posts: "1,540" },
  { name: "重看小时候的老动画", heat: 84, posts: "1,290" },
  { name: "通勤路上都在看什么", heat: 79, posts: "1,120" },
  { name: "一人食到底怎么做", heat: 73, posts: "980" },
];

export const faqs = [
  {
    q: "蘑菇视频在线观看能直接找到热门内容吗？",
    a: "首页把热门视频和短视频合集做成了索引，顶部入口条可以直接跳到关心的板块，不用一层层翻找。更新条会同步展示最近有新内容的合集。",
  },
  {
    q: "短视频合集和专题合集有什么区别？",
    a: "短视频合集偏单条时长短、能连续看的片段；专题合集是按题材把相关视频整理成一组，适合一次性看个够。两种都在首页有独立分区。",
  },
  {
    q: "有什么好看的推荐是怎么整理的？",
    a: "推荐指南按场景和心情分组，比如只有五分钟、需要放空、想涨知识，先选自己当下的状态，再从对应列表里挑。",
  },
  {
    q: "资源速查能查到哪些维度？",
    a: "可以按题材、时长、场景和热度四种方式查，也可以直接用关键词搜，适合明确知道自己想看什么的情况。",
  },
];

export const footerColumns = [
  {
    title: "浏览入口",
    links: ["专题索引", "热门更新", "短视频合集", "资源速查"],
  },
  {
    title: "按题材",
    links: ["影像记录", "解压治愈", "知识科普", "动漫动画", "美食生活"],
  },
  {
    title: "帮你更快找到",
    links: ["有什么好看", "常见问答", "更新条说明", "合集整理规则"],
  },
];